import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { BanReasonCode } from '@module/assignment';
import { getSecurityRuleLabel, getSecurityRuleLabels } from './security-rule-labels';
import { countSecurityTracingsByRule } from './security-tracing-counts';

function isValidSnapshot(snapshot) {
  if (!snapshot || !Number.isSafeInteger(snapshot.violationCount) || !Number.isFinite(snapshot.maximumFoulsAllowed) || snapshot.maximumFoulsAllowed <= 0 || snapshot.violationCount < snapshot.maximumFoulsAllowed || !Array.isArray(snapshot.countsByRule) || !snapshot.countsByRule.length) return false;
  var ids = new Set();
  var total = 0;
  var hasValidCounts = snapshot.countsByRule.every(function (rule) {
    if (!rule || typeof rule.securityOptionId !== 'string' || !rule.securityOptionId.trim() || ids.has(rule.securityOptionId) || !Number.isSafeInteger(rule.count) || rule.count < 1) return false;
    ids.add(rule.securityOptionId);
    total += rule.count;
    return true;
  });
  return hasValidCounts && total === snapshot.violationCount;
}

export function getSubmissionBanExplanation(submission, t) {
  var _submission$securityT;

  var information = submission === null || submission === void 0 ? void 0 : submission.banInformation;
  var isSecurityBan = (information === null || information === void 0 ? void 0 : information.reasonCode) === BanReasonCode.securityViolationLimit.value;
  var snapshot = isSecurityBan && isValidSnapshot(information.securityViolation) ? information.securityViolation : undefined;
  var counts = snapshot ? new Map(snapshot.countsByRule.map(function (_ref) {
    var securityOptionId = _ref.securityOptionId,
        count = _ref.count;
    return [securityOptionId, count];
  })) : countSecurityTracingsByRule((_submission$securityT = submission === null || submission === void 0 ? void 0 : submission.securityTracings) !== null && _submission$securityT !== void 0 ? _submission$securityT : []);
  var ruleLabels = getSecurityRuleLabels(t, 'violations');

  var formatCount = function formatCount(count) {
    return t(count === 1 ? 'securityBan.oneViolation' : 'securityBan.manyViolations', {
      count: count
    });
  };

  var details = _toConsumableArray(counts).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        id = _ref3[0],
        count = _ref3[1];

    return {
      label: snapshot ? getSecurityRuleLabel(id, ruleLabels) : t('securityBan.recordedRule', {
        rule: getSecurityRuleLabel(id, ruleLabels)
      }),
      value: formatCount(count)
    };
  });

  var reason;

  if (!snapshot) {
    if (isSecurityBan) {
      reason = t('securityBan.reason');
    } else {
      var _information$message;

      reason = (information === null || information === void 0 ? void 0 : (_information$message = information.message) === null || _information$message === void 0 ? void 0 : _information$message.trim()) || t('securityBan.fallbackReason');
    }
  }

  return {
    reason: reason,
    details: details
  };
}